import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  TextareaAutosize,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'
import RadioInput from 'components/Radio/RadioInput'
import Editor from 'components/editor'
const CreateModal = ({ handleRefresh, Categories, Types, Tags, Dash_tags, business_types, staff }) => {
  const uploadImage = useUploadImage()
  // select
  const staffOptions = staff?.map(item => ({
    label: item?.username,
    value: item?._id,
  }))

  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()
  var axios = require('axios')

  const types = [
    {
      label: 'Agency',
      value: 'agency',
    },
    {
      label: 'Subaccount',
      value: 'sub_account',
    },
    {
      label: 'Agency & Subaccount',
      value: 'both',
    },
  ]

  const roadmapStatus = [
    {
      label: 'Wish List',
      value: 'wish-list',
    },
    {
      label: 'Planned',
      value: 'planned',
    },
    {
      label: 'In Progress',
      value: 'in-progress',
    },
    {
      label: 'Testing (Beta)',
      value: 'testing',
    },
    {
      label: 'Completed',
      value: 'completed',
    },
  ]

  const status = [
    {
      label: 'Active',
      value: 'active',
    },
    {
      label: 'Inactive',
      value: 'inactive',
    },
    {
      label: 'Beta',
      value: 'beta',
    },
  ]
  const integration_type = [
    {
      label: 'Auth',
      value: 'auth',
    },
    {
      label: 'Form',
      value: 'form',
    },
    {
      label: 'Url',
      value: 'url',
    },
  ]
  const timeline = [
    {
      label: '7 Days',
      value: '7 days',
    },
    {
      label: '14 Days',
      value: '14 days',
    },
    {
      label: '30 Days',
      value: '30 days',
    },
    {
      label: '60 Days',
      value: '60 days',
    },
    {
      label: '90 Days',
      value: '90 days',
    },
  ]
  const SubscriptionTypes = [
    {
      label: 'Free',
      value: 'free',
    },
    {
      label: 'Paid',
      value: 'paid',
    },
    {
      label: 'Unlimited',
      value: 'unlimited',
    },
  ]
  const FeaturesList = [
    {
      label: 'Snapshot',
      value: 'snapshot',
    },
    {
      label: 'Widget',
      value: 'widget',
    },
    {
      label: 'Custom Js',
      value: 'custom_js',
    },
    {
      label: 'Payment Provider',
      value: 'payment_provider',
    },
    {
      label: 'Actions',
      value: 'actions',
    },
    {
      label: 'Triggers',
      value: 'triggers',
    },
    {
      label: 'Conversation Providers',
      value: 'conversation_providers',
    },
  ]
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => { }, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [goingToLive, setGoingToLive] = useState(false);

    const handleCheckboxChange = (event) => {
      setGoingToLive(event.target.checked);
    };

    const handleSubmit = async (e) => {
      e.preventDefault()

      // const app_type = JSON.parse(e.target.app_type.value).value
      const app_type = ''
      let image_response;
      if (goingToLive) {
        image_response = await uploadImage({
          file: e.target?.image?.files?.[0],
          desiredPath: `app/logo/image`,
        })
      }

      const payload = {
        name: e.target.name.value,
        description: e.target.description.value,
        categories: JSON.parse(e.target.categories.value),
        staff: e.target.staff ? JSON.parse(e.target.staff.value) : [],
        distinguish_type: e.target.distinguish_type && e.target.distinguish_type.value
          ? JSON.parse(e.target.distinguish_type.value)
          : {},
        business_type: e.target.business_type && e.target.business_type.value
          ? JSON.parse(e.target.business_type.value)
          : {},
        tags: e.target.tags && e.target.tags.value ? JSON.parse(e.target.tags.value) : [],
        dash_tags: e.target.dash_tags && e.target.dash_tags.value
          ? JSON.parse(e.target.dash_tags.value)
          : [],
        video_url: e.target.video_url.value,
        app_features: JSON.parse(e.target.app_features.value),
        app_subscription_type: e.target.app_subscription_type?.value,
        app_id: e.target?.app_id?.value,
        client_id: e.target?.client_id?.value,
        client_secret: e.target?.client_secret?.value,
        sso: e.target?.sso?.value,
        app_type: e.target?.app_type ? JSON.parse(e.target?.app_type?.value) : '',
        status: JSON.parse(e.target.status.value),
        roadmap_status: JSON.parse(e.target.roadmap_status.value),
        image: image_response?.response.data,
        app_triggers: e.target.app_triggers.checked,
        hasUIInterface: e.target.hasUIInterface.checked,
        default_app: e.target.default_app.checked,
        ghl_add_on: e.target.ghl_add_on.checked,


        location_tool: e.target.location_tool.checked,

        user_id: user._id,
        url: e.target.url.value,
        custom_page: e.target.custom_page.value,
        agency_custom_page: e.target.agency_custom_page.value,
        ghlLocations_enable: app_type == 'agency' ? e.target.ghlLocations_enable.checked : false,
        ghlusers_enable: app_type == 'agency' ? e.target.ghlusers_enable.checked : false,
        location_modal_key: app_type == 'agency' && e.target.ghlLocations_enable.checked == true
          ? e.target.location_modal_key.value
          : null,
        location_auth: app_type == 'agency' && e.target.ghlLocations_enable.checked == true
          ? e.target.location_auth.checked
          : null,
        user_modal_key: app_type == 'agency' && e.target.ghlusers_enable.checked == true
          ? e.target.user_modal_key.value
          : null,
        dont_show: e.target.dont_show.checked,
        dont_show_location: e.target.dont_show_location.checked,
        included_all_the_apps: e.target.included_all_the_apps.checked,


      }

      console.log('payloadpayloadpayload', payload)
      // return 0

      const { response } = await AppService.app.create({
        payload: payload,
      })
      // console.log(response)
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    function IN() {
      const [integrationValue, setIntegrationValue] = useState('')
      const [editor, setEditor] = useState(null)

      return (
        <>
          <MDBox sx={{ fontSize: '15px' }}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Integration Type
            </MDTypography>
            <Multiselect
              data={integration_type}
              edit_data={[]}
              isMulti={false}
              name="integration_type"
              onChange={setIntegrationValue}
            />
          </MDBox>
          {integrationValue == 'form' ? (
            <>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Content
                </MDTypography>
                <Editor
                  handleChange={(data) => {
                    // console.log('html', data)
                    setEditor(data)
                  }}
                  data={editor}
                />
              </MDBox>
            </>
          ) : (
            <></>
          )}
          {integrationValue == 'auth' ? (
            <>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  url
                </MDTypography>
                <MDInput label="url" name="url" fullWidth />
              </MDBox>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Content
                </MDTypography>
                <Editor
                  handleChange={(data) => {
                    // console.log('html', data)
                    setEditor(data)
                  }}
                  data={editor}
                />
              </MDBox>
            </>
          ) : (
            <></>
          )}
          {integrationValue == 'url' ? (
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                url
              </MDTypography>
              <MDInput label="url" name="url" fullWidth />
            </MDBox>
          ) : (
            <></>
          )}
          <input type="hidden" name="content" value={editor} />
        </>
      )
    }
    function AppType() {
      const [apptype, setApptype] = useState('')
      const [ghlLocations_enable, setGhlLocations_enable] = useState(false)
      const [ghlusers_enable, setGhlUsers_enable] = useState(false)
      return (
        <>
          <MDBox sx={{ fontSize: '15px' }}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Type
            </MDTypography>
            <Multiselect
              data={types}
              edit_data={[]}
              isMulti={false}
              name="app_type"
              onChange={setApptype}
            />
          </MDBox>

          {apptype == 'agency' || apptype == 'both' ? (
            <>
              {/* <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  limited Monthly Plan Id
                </MDTypography>
                <MDInput label="limited Monthly Plan Id" name="limited_monthly_id" fullWidth />
              </MDBox>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  limited Monthly Price
                </MDTypography>
                <MDInput type="number" label="limited Monthly Price" name="limited_monthly_price" fullWidth />
              </MDBox>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  limited Yearly Plan Id
                </MDTypography>
                <MDInput label="limited Yearly Plan Id" name="limited_yearly_id" fullWidth />
              </MDBox>
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  limited Yearly Price
                </MDTypography>
                <MDInput type="number" label="limited Yearly Price" name="limited_yearly_price" fullWidth />
              </MDBox> */}
              <MDBox>
                <FormControlLabel
                  control={
                    <Switch
                      name="ghlLocations_enable"
                      checked={ghlLocations_enable}
                      onChange={(e) => setGhlLocations_enable(e.target.checked)}
                    />
                  }
                  label="is ghl location is required for this app?"
                />
                {ghlLocations_enable && (
                  <MDBox mt={-1}>
                    <MDBox>
                      <MDTypography
                        variant="button"
                        sx={{ fontSize: '14px', fontWeight: '500' }}
                        mb={1}
                      >
                        Location Modal Key
                      </MDTypography>
                      <MDInput label="Location Modal Auth" name="location_modal_key" fullWidth />
                    </MDBox>
                    <MDBox>
                      <FormControlLabel
                        control={<Checkbox name="location_auth" />}
                        label="is auth tokens required for the locations?"
                      />
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
              <MDBox>
                <FormControlLabel
                  control={
                    <Switch
                      name="ghlusers_enable"
                      checked={ghlusers_enable}
                      onChange={(e) => setGhlUsers_enable(e.target.checked)}
                    />
                  }
                  label="is ghl user is required for this app?"
                />
                {ghlusers_enable && (
                  <MDBox mt={-1}>
                    <MDTypography
                      variant="button"
                      sx={{ fontSize: '14px', fontWeight: '500' }}
                      mb={1}
                    >
                      User Modal Key
                    </MDTypography>
                    <MDInput label="User Modal Key" name="user_modal_key" fullWidth />
                  </MDBox>
                )}
              </MDBox>
            </>
          ) : (
            <></>
          )}
        </>
      )
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Register App
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <MDBox>
                <TextareaAutosize
                  type="text"
                  name="description"
                  minRows={3}
                  style={{ width: '100%' }}
                />
              </MDBox>
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Categories
              </MDTypography>
              <Multiselect data={Categories} edit_data={[]} isMulti={true} name="categories" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect data={Types} edit_data={[]} isMulti={true} name="distinguish_type" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Staff to assign
              </MDTypography>
              <Multiselect data={staffOptions} edit_data={[]} isMulti={true} name="staff" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Business Type
              </MDTypography>
              <Multiselect
                data={business_types}
                edit_data={[]}
                isMulti={true}
                name="business_type"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tags
              </MDTypography>
              <Multiselect data={Tags} edit_data={[]} isMulti={true} name="tags" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Dashboard Tags
              </MDTypography>
              <Multiselect data={Dash_tags} edit_data={[]} isMulti={true} name="dash_tags" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Video Url
              </MDTypography>
              <MDInput label="Video Url" name="video_url" fullWidth />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Features
              </MDTypography>
              <Multiselect data={FeaturesList} edit_data={[]} isMulti={true} name="app_features" />
            </MDBox>

            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Subscription Type
              </MDTypography>
              <Multiselect data={SubscriptionTypes} isMulti={false} name="app_subscription_type" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Status
              </MDTypography>
              <Multiselect data={status} edit_data={[]} isMulti={false} name="status" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Roadmap Status
              </MDTypography>
              <Multiselect
                data={roadmapStatus}
                edit_data={[]}
                isMulti={false}
                name="roadmap_status"
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Form url
              </MDTypography>
              <MDInput label="url" name="url" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page
              </MDTypography>
              <MDInput label="custom_page" name="custom_page" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Agency Custom Page
              </MDTypography>
              <MDInput label="agency_custom_page" name="agency_custom_page" fullWidth />
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is App Have Triggers"
                  name="app_triggers"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is App Have Trigger Interface"
                  name="hasUIInterface"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="mark as default alltheapps App"
                  name="default_app"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="mark as ghl add on"
                  name="ghl_add_on"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="mark as Location Tool alltheapps App"
                  name="location_tool"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is it included in all the apps"
                  name="included_all_the_apps"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                 control={<Checkbox />}
                 label="Hide App"
                  name="dont_show" 
                  />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Hide App from location"
                  name="dont_show_location"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={goingToLive}
                      onChange={handleCheckboxChange}
                      name="is_going_to_live"
                    />
                  }
                  label="App ready to publish"
                />
              </FormGroup>
            </MDBox>
            {goingToLive && (
              <>
                <hr />
                <MDBox
                  mt={2}
                  mb={2}
                  ml={0}
                  display="flex"
                  alignItems="start"
                  flexDirection="column"
                >
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Images
                  </MDTypography>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                      Upload Image +
                      <input hidden name="image" type="file" />
                    </Button>
                  </Stack>
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Id
                  </MDTypography>
                  <MDInput label="App Id" placeholder="App Id" name="app_id" fullWidth />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Id
                  </MDTypography>
                  <MDInput label="Client Id" placeholder="Client Id" name="client_id" fullWidth />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Secret
                  </MDTypography>
                  <MDInput
                    label="Client Secret"
                    placeholder="Client Secret"
                    name="client_secret"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    SSO Key
                  </MDTypography>
                  <MDInput label="SSO Key" placeholder="SSO Key" name="sso" fullWidth />
                </MDBox>
              </>
            )}

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
